module.exports = __webpack_public_path__ + "static/media/samoyed_dog.5d4c7181.png";